import brand from "./brand.json" with { type: "json" };

/**
 * Ürün markası — tek kaynak `brand.json` (web, API, e-posta, brand/tools ve ileride native
 * uygulamalar buradan okur). Kullanıcıya görünen hiçbir yerde ad elle yazılmaz.
 *
 * - `tr`: Türkçe ekli biçimler. Ad "yirmi bir ik" okunur; ek son heceye ("ik") göre çekimlenir
 *   ve kesme işaretiyle ayrılır. Cümleye `{brand}'ya` gibi kalıpla eklenmez, buradan alınır.
 * - `native`: Android uygulama kimliğinde her parça harfle başlamak zorunda olduğu için
 *   "21ik" yerine okunuşu ("yirmibirik") kullanılır; mağazaya çıktıktan sonra değişmez.
 * - Teknik kimlikler (`@hik/` paketleri, `hik_session` çerezi, `x-hik-client` başlığı,
 *   veritabanı rolleri) markadan bağımsızdır ve değişmez (docs/DECISIONS.md K-017).
 */
export const BRAND = brand;
export type Brand = typeof brand;
